/**
 * Checks if the given string is valid JSON.
 *
 * @param str - The string to check.
 * @returns True if the string is valid JSON, false otherwise.
 */

export function isValidJsonString(str: string) {
  try {
    JSON.parse(str)
  } catch {
    return false
  }
  return true
}
